import { FilterableInterface } from './filterable.interface';

export class BaseManufacturingOrder implements FilterableInterface {
  constructor(
    public hash?: string,
    public code?: string,
    public project?: string,
    public customer?: string,
    public subCustomer?: string,
    public reference?: string,
    public projectNumber?: string,
    public description?: string,
    public typeManufacturingOrder?: boolean,
    public typeNonProductiveManufacturingOrder?: boolean
  ) { }

  get filterableData() {
    return `${ this.code } ${ this.projectNumber }
    ${ this.customer } ${ this.subCustomer } ${ this.reference } ${ this.project } ${ this.description }`
      .toLowerCase();
  }

  get codeWithNumber() {
    return `${ this.code }/${ this.projectNumber }`;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/base-manufacturing-order.ts